import React, { useCallback } from 'react'
import { Form, Input, Upload, Button, Row, Col, Switch } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'
import './styles.scss'
import { isEmpty } from 'lodash'

const getBase64 = async (audio) => {
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.addEventListener('load', () => resolve(reader.result))
    reader.addEventListener('error', reject)
    reader.readAsDataURL(audio)
  })
}
export const KaraokeForm = ({ form, onFinish, initialValues, ...props }) => {
  return (
    <Form
      component={false}
      form={form}
      initialValues={initialValues}
      onFinish={onFinish}
      labelCol={{ span: 24 }}
      {...props}
    />
  )
}

const AudioInput = (props) => {
  const { onChange, value } = props
  const handleBeforeUpload = useCallback(async (file) => {
    const isMp3 = file.type === 'audio/mpeg'
    if (!isMp3) {
      // message.error('You can only upload audio/mpeg file!')
      return false
    }

    const src = await getBase64(file)
    const audio = {
      file: file,
      blob: file,
      name: file.name,
      src,
    }
    onChange(audio)
    return false
  }, [])

  return (
    <Row align="middle">
      <Col>
        <Upload
          beforeUpload={handleBeforeUpload}
          multiple={false}
          showUploadList={false}
        >
          <Button>
            <PlusCircleOutlined />
            Select Song
          </Button>
        </Upload>
      </Col>
      <Col flex={1}>
        <audio controls className="form-audio" src={value && value.src} />
      </Col>
    </Row>
  )
}

const InputItem = (props) => (
  <Col flex={1}>
    <Form.Item {...props} />
  </Col>
)
const SwithInput = ({ value, ...props }) => (
  <Switch checked={value} {...props} />
)
export const KaraokeDetailsForm = ({ form, initialValues, onFinish }) => {
  return (
    <>
      <KaraokeForm
        form={form}
        initialValues={initialValues}
        onFinish={onFinish}
      >
        <Row gutter={[16, 0]}>
          <InputItem
            label="Title"
            name="title"
            rules={[{ type: 'string', required: true }]}
          >
            <Input />
          </InputItem>
          <InputItem
            label="Artist"
            name="artist"
            rules={[{ type: 'string', required: true }]}
          >
            <Input />
          </InputItem>
          <InputItem label="Album" name="album" rules={[{ type: 'string' }]}>
            <Input />
          </InputItem>
          <InputItem label="Spotify ID" name="spotifyId">
            <Input />
          </InputItem>
          <InputItem label="Has vocals" name="hasVocals">
            <SwithInput />
          </InputItem>
        </Row>
        <Form.Item name="audio" rules={[{ type: 'object', required: true }]}>
          <AudioInput />
        </Form.Item>
      </KaraokeForm>
    </>
  )
}
